export const challanPageLoad = {
    event: "landing_page_trigger",
    eventAction: "landing_page_trigger",
    eventCategory: "challan_landing_page"
};
